"use strict";
// create a function that checks if window object is available and pushes the form values to the data layer in window object
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushFormSuccessValuestoDataLayer = void 0;
const pushFormSuccessValuestoDataLayer = (formValues) => {
    if (typeof globalThis !== 'undefined') {
        globalThis.dataLayer = globalThis.dataLayer || []; // initialize the dataLayer array if it doesn't exist
        globalThis.dataLayer.push({
            event: 'em.formSubmitSuccess',
            ...formValues,
        });
    }
};
exports.pushFormSuccessValuestoDataLayer = pushFormSuccessValuestoDataLayer;
